import Metadata from './metadata.js';
export default function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountries.js
// module id = 1120
// module chunks = 22